import { FormData } from './FormCollector'

export type ValidationFunction = (value: string) => boolean

export const email: ValidationFunction = value => {
  return /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$/.test(value)
}

export const equals = (original: string): ValidationFunction => {
  return value => {
    if (value === null) {
      return false
    }
    return value === original
  }
}

export const maxLength = (max: number): ValidationFunction => {
  return value => {
    if (value === null) {
      return false
    }
    return value.length <= max
  }
}

export const minLength = (min: number): ValidationFunction => {
  return value => {
    if (value === null) {
      return false
    }
    return value.length >= min
  }
}

export const match = (key: string, formData: FormData): ValidationFunction => {
  return value => {
    if (value === null) {
      return false
    }
    return value === formData[key]
  }
}

export const regExp = (reg: RegExp): ValidationFunction => value =>
  value ? reg.test(value) : false

export const boolean = (value: string) => value === 'true'
